import React, { memo, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, Text, Select, FieldGroup, Input } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';
import SmsCode from '../icons/SmsCode';

import styles from './styles';
const useStyles = createUseStyles(styles, 'EnterPhone');

const EnterPhone = ({ countriesList, country, error, setCountry, phoneNumber, setPhoneNumber }) => {
    const classes = useStyles();
    const { t } = useWeb5Context();

    const onChangePhone = useCallback(
        (_, value) => {
            setPhoneNumber(value || '');
        },
        [setPhoneNumber],
    );

    const values = useMemo(
        () => [country ? `+${country.prefix}` : '', phoneNumber ? phoneNumber.toString() : ''],
        [phoneNumber, country],
    );

    if (!countriesList) return null;

    return (
        <div className={classes.root}>
            <div className={classes.intro}>
                <SmsCode className={classes.introIcon} />
                <Text className={classes.blueBoxText}>
                    {t('cfm_label_2fa_enter_phone_number_desc')}
                </Text>
            </div>
            <Select
                label={t('cfm_label_2fa_country_code')}
                placeholder={t('cfm_placeholder_2fa_country_code')}
                onChange={setCountry}
                options={countriesList}
                value={country}
                isFullWidth
            />
            <FieldGroup
                label={t('cfm_label_2fa_enter_phone_number')}
                inputs={[Input, Input]}
                inputProps={[
                    {
                        className: classes.prefix,
                        isReadOnly: true,
                        placeholder: '+',
                    },
                    {
                        className: classes.phone,
                        placeholder: t('cfm_placeholder_2fa_phone_number'),
                        error,
                    },
                ]}
                className={classes.groupPhone}
                onChange={onChangePhone}
                value={values}
                isFullWidth
            />
        </div>
    );
};

EnterPhone.propTypes = {
    countriesList: PropTypes.array,
    country: PropTypes.object,
    error: PropTypes.string,
    setCountry: PropTypes.func,
    phoneNumber: PropTypes.func,
    setPhoneNumber: PropTypes.func,
    finish2FA: PropTypes.func,
};

export default memo(EnterPhone);
